<template>
  <div class="multiCloudCluster-container">
    <div class="multiCloudCluster-head base-background__white"></div>
    <el-tabs v-model="activeName" class="multiCloudCluster-tab" @tab-click="tabClick">
      <!-- 多云集群列表  分区列表 -->
      <el-tab-pane :label="$t('multiCloudCluster.partitionList')" name="partitionList">
        <!-- 无多云集群显示 -->
        <div
          v-if="(multiCloudList === null || multiCloudList.length === 0) && !isFilter"
          class="empty base-flex__cross-center base-background__white base-flex__center"
        >
          <el-empty :description="$t('multiCloudCluster.noMultiCloudCluster')">
            <el-button type="text" @click="openCreatePartitionDialog"
              >{{ $t('multiCloudCluster.createNow') }}
            </el-button>
          </el-empty>
        </div>

        <div v-else class="multiCloudCluster-tab__container">
          <div class="base-flex__between base-margin__bottom-10">
            <el-button type="primary" @click="openCreatePartitionDialog"
              >{{ $t('multiCloudCluster.createPartition') }}
            </el-button>
            <div class="base-flex">
              <el-select
                v-model="cloudType"
                :placeholder="$t('multiCloudCluster.selectCloudType')"
                clearable
                @change="getMulticloudPartitionList"
              >
                <el-option v-for="item in providerOptions" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
              <el-input
                v-model="searchName"
                :placeholder="$t('multiCloudCluster.inputName')"
                class="base-margin__left-10"
                clearable
                @change="getMulticloudPartitionList"
              ></el-input>
            </div>
          </div>
          <div class="table_box">
            <el-table :data="multiCloudList" class="table" v-loading="multiCloudListLoading">
              <el-table-column :label="$t('multiCloudCluster.idName')" prop="Name">
                <template slot-scope="scope">
                  <p>{{ scope.row.Id }}</p>
                  <p class="base-color__light_blue base-cursor__pointer" @click="toDetail(scope.row)">
                    {{ scope.row.Name }}
                  </p>
                </template>
              </el-table-column>
              <el-table-column :label="$t('multiCloudCluster.region')" prop="Region"></el-table-column>
              <el-table-column :label="$t('customCluster.customList.regionZone')" prop="Zone"></el-table-column>
              <el-table-column :label="$t('multiCloudCluster.cloudProvider')" prop="Provider">
                <template slot-scope="scope">
                  <div class="provider_div base-flex__cross-center">
                    <img v-if="scope.row.Provider === 'aliyun'" src="@/views/multiCloudCluster/image/aliyun.svg" />
                    <img
                      v-else-if="scope.row.Provider === 'huaweicloud'"
                      src="@/views/multiCloudCluster/image/huawei.svg"
                    />
                    <img
                      v-else-if="scope.row.Provider === 'volcengine'"
                      src="@/views/multiCloudCluster/image/volcengine.svg"
                    />
                    <span class="base-margin__left-8">{{ providerList[scope.row.Provider] }}</span>
                  </div>
                </template>
              </el-table-column>
              <el-table-column :label="$t('multiCloudCluster.instanceCount')" prop="InstanceCount"></el-table-column>
              <el-table-column :label="$t('computingCluster.clusterEnv.vpc')" prop="VpcId"></el-table-column>
              <el-table-column :label="$t('computingCluster.clusterEnv.subnetId')" prop="SubnetId"></el-table-column>
              <el-table-column :label="$t('multiCloudCluster.description')">
                <template slot-scope="scope">
                  <span>{{ scope.row.Description || '-' }}</span>
                </template>
              </el-table-column>
              <el-table-column :label="$t('multiCloudCluster.createTime')" prop="CreateTime"></el-table-column>
              <el-table-column :label="$t('multiCloudCluster.actions')">
                <template slot-scope="scope">
                  <el-button size="small" type="text" @click="modify(scope.row)"
                    >{{ $t('multiCloudCluster.edit') }}
                  </el-button>
                  <el-button size="small" type="text" @click="deleteMultiCloudPartition(scope.row)">
                    {{ $t('multiCloudCluster.delete') }}
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
            <el-pagination
              :current-page="partitionCurrentPage"
              :page-size="10"
              :page-sizes="[10, 20, 50, 100]"
              :total="partitionTotal"
              align="right"
              class="base-margin__top-10"
              layout="total, sizes, prev, pager, next, jumper"
              @size-change="partitionSizeChange"
              @current-change="partitionCurrentChange"
            >
            </el-pagination>
          </div>
        </div>
      </el-tab-pane>

      <!-- 多云集群列表  云环境列表 -->
      <el-tab-pane :label="$t('multiCloudCluster.cloudEnvironmentList')" name="cloudEnvironment">
        <!-- 无多云集群显示 -->
        <div
          v-if="cloudEnvironmentList === null || cloudEnvironmentList.length === 0"
          class="empty base-flex__cross-center base-background__white base-flex__center"
        >
          <el-empty :description="$t('multiCloudCluster.noCloudEnvironment')">
            <el-button type="text" @click="openAgreeDialog(false)">{{ $t('multiCloudCluster.createNow') }}</el-button>
          </el-empty>
        </div>

        <div v-else class="cloudEnvironment-container base-background__white">
          <div v-for="item in cloudEnvironmentList" :key="item.Id" class="cloudEnvironment-container__card">
            <div class="base-flex__between">
              <span></span>
              <div class="card_head-icon">
                <i class="el-icon-edit-outline" @click="edit(item)"></i>
                <i class="el-icon-delete" @click="deleteCloudEnv(item.Id)"></i>
              </div>
            </div>
            <div class="base-flex">
              <div class="card_left">
                <img v-if="item.Provider === 'aliyun'" src="@/views/multiCloudCluster/image/aliyun.svg" />
                <img v-else-if="item.Provider === 'huaweicloud'" src="@/views/multiCloudCluster/image/huawei.svg" />
                <img v-else-if="item.Provider === 'volcengine'" src="@/views/multiCloudCluster/image/volcengine.svg" />
                <span class="base-margin__bottom-10">{{ providerList[item.Provider] }}</span>
                <div>
                  <span>{{ $t('multiCloudCluster.currentStatus') }}</span>
                  <span>{{ $t('multiCloudCluster.connected') }}</span>
                </div>
              </div>
              <div class="card_right">
                <div class="card_right-info">
                  <div>
                    <div>
                      <span>{{ $t('multiCloudCluster.subCluster') }}</span
                      ><span>：</span>
                    </div>
                    <span>-</span>
                  </div>
                  <div>
                    <div>
                      <span>{{ $t('multiCloudCluster.storage') }}</span
                      ><span>：</span>
                    </div>
                    <span>-</span>
                  </div>
                  <div>
                    <div>
                      <span>{{ $t('multiCloudCluster.network') }}</span
                      ><span>：</span>
                    </div>
                    <span>-</span>
                  </div>
                  <div>
                    <div>
                      <span>{{ $t('multiCloudCluster.virtualMachine') }}</span
                      ><span>：</span>
                    </div>
                    <span>-</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="base-margin__top-20">
              <span>secretID: </span><span>{{ processSecretID(item.SecretId) }}</span>
            </div>
          </div>
          <div
            v-if="cloudEnvironmentList.length < 3"
            class="cloudEnvironment-container__card base-cursor__pointer base-flex__cross-center base-flex__center"
            @click="openAgreeDialog(false)"
          >
            <i class="base-font-size__36px base-color__grey el-icon-plus"></i>
          </div>
        </div>
      </el-tab-pane>

      <!-- 实例模版 -->
      <el-tab-pane :label="$t('multiCloudCluster.instanceTemplate')" name="instanceTemplate">
        <InstanceTemplate v-if="activeName === 'instanceTemplate'"></InstanceTemplate>
      </el-tab-pane>

      <!-- 日志管理 -->
      <el-tab-pane :label="$t('computingCluster.logManagement')" name="activity">
        <activity v-if="activeName === 'activity'" />
      </el-tab-pane>

      <!-- 成本分析 -->
      <el-tab-pane :label="$t('multiCloudCluster.costAnalysis')" name="costAnalysis">
        <cost-analysis v-if="activeName === 'costAnalysis'" />
      </el-tab-pane>
    </el-tabs>

    <!-- 创建分区 编辑分区 -->
    <el-dialog
      :close-on-click-modal="false"
      :destroy-on-close="true"
      :title="isModify ? $t('multiCloudCluster.modifyPartition') : $t('multiCloudCluster.createPartition')"
      :visible.sync="createPartitionDialogVisible"
      width="700px"
      @close="closePartitionDialog"
    >
      <div class="box_clas">
        <el-steps :active="createSteps" align-center class="base-margin__bottom-10" finish-status="success" v-if="!isModify">
          <el-step :title="$t('customCluster.createCluster.step.clusterInfo')"></el-step>
          <el-step :title="$t('customCluster.createCluster.step.ipHostnameMapping')"></el-step>
          <el-step :title="$t('customCluster.createCluster.step.previewIp')"></el-step>
        </el-steps>
        <!-- 创建信息 -->
        <el-form
          v-if="createSteps === 0"
          ref="partitionForm"
          v-loading="partitionFormLoading"
          :model="partitionFormData"
          :rules="partitionFormRules"
          label-position="right"
          label-width="100px"
        >
          <el-form-item :label="$t('multiCloudCluster.name')" prop="name">
            <el-input
              v-model="partitionFormData.name"
              :placeholder="$t('multiCloudCluster.inputPartitionName')"
              maxlength="60"
              show-word-limit
            ></el-input>
          </el-form-item>
          <el-form-item :label="$t('multiCloudCluster.cloudEnvironment')" prop="cloudEnvironment">
            <div class="base-flex">
              <el-select
                v-model="partitionFormData.cloudEnvironment"
                :disabled="isModify"
                :placeholder="$t('multiCloudCluster.selectCloudEnvironment')"
                @change="getRegionsList"
              >
                <el-option
                  v-for="item in cloudEnvironmentList"
                  :key="item.Id"
                  :label="providerList[item.Provider]"
                  :value="item.Id"
                >
                </el-option>
              </el-select>
              <el-button v-if="!isModify" class="base-margin__left-20" type="primary" @click="openAgreeDialog(true)">
                {{ $t('multiCloudCluster.createCloudEnvironment') }}
              </el-button>
            </div>
          </el-form-item>
          <el-form-item :label="$t('customCluster.createCluster.form.privateNetwork')" prop="vpcId">
            <div class="base-flex base-width_fullscreen">
              <el-select
                :disabled="isModify"
                v-model="partitionFormData.region"
                :placeholder="$t('customCluster.createCluster.placeholder.selectRegion')"
                class="formItem__select-short base-margin__right-20"
                filterable
                @change="changeRegion"
              >
                <el-option
                  v-for="item in regionOptions"
                  :key="item.regionId"
                  :label="item.regionName"
                  :value="item.regionId"
                ></el-option>
              </el-select>
              <div class="base-flex base-flex__1">
                <el-select
                  v-model="partitionFormData.vpcId"
                  :placeholder="$t('customCluster.createCluster.placeholder.selectPrivateNetwork')"
                  filterable
                  @change="changeVpc"
                  :disabled="isModify"
                >
                  <el-option
                    v-for="item in vpcList"
                    :key="item.VpcId"
                    :label="`${item.VpcName} | ${item.VpcId} | ${item.CidrBlock}`"
                    :value="item.VpcId"
                  ></el-option>
                </el-select>
              </div>
            </div>
          </el-form-item>

          <el-form-item :label="$t('customCluster.createCluster.form.subnetInfo')" prop="subnetId">
            <div class="base-flex base-width_fullscreen">
              <el-select
                v-model="partitionFormData.zone"
                :placeholder="$t('customCluster.createCluster.placeholder.selectZone')"
                class="formItem__select-short base-margin__right-20"
                @change="changeZone"
                filterable
                :disabled="isModify"
              >
                <el-option v-for="item in zoneList" :key="item.id" :label="item.name" :value="item.id"></el-option>
              </el-select>
              <el-select
                v-model="partitionFormData.subnetId"
                :placeholder="$t('customCluster.createCluster.placeholder.selectSubnetInfo')"
                filterable
                @change="changeSubnet"
                :disabled="isModify"
              >
                <el-option
                  v-for="item in subnetList"
                  :key="item.id"
                  :label="`${item.id} | ${item.name} | ${item.cidrBlock}`"
                  :value="item.id"
                ></el-option>
              </el-select>
            </div>
          </el-form-item>
          <el-form-item
            :label="$t('customCluster.createCluster.form.securityGroup')"
            filterable
            prop="securityGroupIds"
          >
            <div class="base-flex">
              <el-select
                v-model="partitionFormData.securityGroupIds"
                :placeholder="$t('customCluster.createCluster.placeholder.selectSecurityGroup')"
                filterable
                multiple
              >
                <el-option
                  v-for="item in securityGroupsList"
                  :key="item.SecurityGroupId"
                  :label="`${item.SecurityGroupId} | ${item.SecurityGroupName}`"
                  :value="item.SecurityGroupId"
                ></el-option>
              </el-select>
            </div>
          </el-form-item>
        </el-form>
        <!-- ip range -->
        <el-table
          v-if="createSteps === 1"
          :key="JSON.stringify(hostRangeListForm)"
          :data="hostRangeListForm"
          style="width: 100%"
        >
          <el-table-column :label="$t('customCluster.createCluster.table.hostnamePrefix')">
            <template slot-scope="scope">
              <span>
                {{ scope.row.hostnamePattern }}
              </span>
            </template>
          </el-table-column>
          <el-table-column :label="$t('customCluster.createCluster.table.startIp')">
            <template slot-scope="scope">
              {{ formatIp(scope.row.startIp) }}
            </template>
          </el-table-column>
          <el-table-column :label="$t('customCluster.createCluster.table.endIp')">
            <template slot-scope="scope">
              {{ formatIp(scope.row.endIp) }}
            </template>
          </el-table-column>
          <el-table-column :label="$t('customCluster.createCluster.table.startNumber')" prop="indexStart">
          </el-table-column>
          <el-table-column :label="$t('customCluster.createCluster.table.numberDigits')" prop="indexLength">
          </el-table-column>
          <el-table-column :label="$t('customCluster.createCluster.table.operation')" fixed="right" width="100">
            <template slot-scope="scope">
              <el-button size="small" type="text" @click="editHostRangeList(scope.$index, scope.row)">
                {{ $t('customCluster.createCluster.button.edit') }}
              </el-button>
              <el-button size="small" type="text" @click="deleteHostRangeList(scope.$index)">
                {{ $t('customCluster.createCluster.button.delete') }}
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <div v-if="createSteps === 1" class="base-text-align__right base-margin__right-20">
          <el-button class="base-marginTop__10" type="text" @click="addIpRange">
            {{ $t('customCluster.createCluster.button.addIpRange') }}
          </el-button>
        </div>

        <el-table v-if="createSteps === 2" :data="previewList" class="base-width_fullscreen" height="500">
          <el-table-column :label="$t('customCluster.createCluster.table.hostname')" prop="hostname"></el-table-column>
          <el-table-column :label="$t('customCluster.createCluster.table.ip')" prop="ip"></el-table-column>
        </el-table>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="createPartitionDialogVisible = false">{{ $t('multiCloudCluster.cancel') }}</el-button>
        <span v-if="!isModify" class="base-margin__left-10">
          <el-button v-if="createSteps > 0" @click="createSteps--">
            {{ $t('customCluster.customList.previous') }}
          </el-button>
          <el-button
            v-if="createSteps < 2"
            :disabled="createSteps === 1 && hostRangeListForm.length === 0"
            type="primary"
            @click="nextCreateSteps"
          >{{ $t('customCluster.customList.next') }}
          </el-button>
        </span>

        <span class="base-margin__left-10" v-if="createSteps === 2">
          <el-button v-if="!isModify" type="primary" @click="createMulticloudPartition">
            {{ $t('multiCloudCluster.confirm') }}
          </el-button>

        </span>
        <el-button v-if="isModify" type="primary" @click="modifyPartition">
          {{ $t('multiCloudCluster.confirm') }}
        </el-button>
      </span>
    </el-dialog>

    <!--添加 ip端-->
    <el-dialog
      :close-on-click-modal="false"
      :title="`${$t('customCluster.createCluster.dialog.ipRange')} ${partitionFormData.subnetCidrBlock}`"
      :visible.sync="hostRangeListVisible"
      append-to-body
      width="750px"
    >
      <div>
        <el-form ref="hostRangeListForm" label-width="90px">
          <div>
            <div class="ipBox">
              <div class="base-flex base-position__relative startIp_input">
                <span>{{ $t('customCluster.createCluster.label.startIp') }}</span>
                <el-input
                  v-for="(item, ipStartIndex) in showHostRangeListForm.startIp"
                  :key="ipStartIndex + 10"
                  v-model="item.value"
                  :disabled="item.disabled"
                  type="number"
                >
                </el-input>
                <span>{{ $t('customCluster.createCluster.label.endIp') }}</span>
                <el-input
                  v-for="(item, ipEndIndex) in showHostRangeListForm.endIp"
                  :key="ipEndIndex + 100"
                  v-model="item.value"
                  :disabled="item.disabled"
                  type="number"
                >
                </el-input>
              </div>
              <div class="tips_cls">{{ $t('customCluster.createCluster.tips.reservedIps') }}</div>
              <div class="base-flex base-position__relative startIp_input">
                <span>{{ $t('customCluster.createCluster.label.hostnamePrefix') }}</span>
                <el-input
                  v-model="showHostRangeListForm.hostnamePattern"
                  :placeholder="$t('customCluster.createCluster.placeholder.enterHostname')"
                  class="div-width__180"
                ></el-input>
                <span>{{ $t('customCluster.createCluster.label.startNumber') }}</span>
                <el-input v-model="showHostRangeListForm.indexStart" type="number"></el-input>
                <span>{{ $t('customCluster.createCluster.label.numberDigits') }}</span>
                <el-input v-model="showHostRangeListForm.indexLength" type="number"></el-input>
                <div class="preview_div--button base-cursor__pointer base-color__light_blue" @click="preview">
                  {{ $t('customCluster.createCluster.button.preview') }}
                </div>
              </div>
            </div>
          </div>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeHostList">{{ $t('customCluster.createCluster.button.cancel') }}</el-button>
        <el-button type="primary" @click="doneEditHostRangeList">{{
          $t('customCluster.createCluster.button.confirm')
        }}</el-button>
      </span>
    </el-dialog>

    <!-- 创建云环境 编辑云环境-->
    <el-dialog
      :close-on-click-modal="false"
      :destroy-on-close="true"
      :title="
        isEditCloudEnv ? $t('multiCloudCluster.modifyCloudEnvironment') : $t('multiCloudCluster.createCloudEnvironment')
      "
      :visible.sync="createCloudEnvironmentDialogVisible"
      width="600px"
      @close="clearCloudEnvironmentFormData"
    >
      <el-form
        ref="CloudEnv"
        v-loading="cloudEnvLoading"
        :model="cloudEnvironmentFormData"
        :rules="CloudEnvFormRules"
        label-position="right"
        label-width="100px"
      >
        <el-form-item v-if="!isEditCloudEnv" :label="$t('multiCloudCluster.cloudProvider')" prop="provider">
          <el-select
            v-model="cloudEnvironmentFormData.provider"
            :placeholder="$t('multiCloudCluster.selectCloudProvider')"
          >
            <el-option
              v-for="item in providerOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('multiCloudCluster.accessKeyId')" prop="secretId">
          <el-input
            v-model="cloudEnvironmentFormData.secretId"
            :placeholder="$t('multiCloudCluster.inputAccessKeyId')"
          ></el-input>
        </el-form-item>
        <el-form-item :label="$t('multiCloudCluster.accessKeySecret')" prop="secretKey">
          <el-input
            v-model="cloudEnvironmentFormData.secretKey"
            show-password
            :placeholder="$t('multiCloudCluster.inputAccessKeySecret')"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="createCloudEnvironmentDialogVisible = false">{{ $t('multiCloudCluster.cancel') }}</el-button>
        <el-button
          v-if="!isEditCloudEnv"
          :disabled="isCreateMultiCloudAccount"
          type="primary"
          @click="createMultiCloudAccount"
          >{{ $t('multiCloudCluster.confirm') }}</el-button
        >
        <el-button v-else type="primary" @click="editCloudEnv">{{ $t('multiCloudCluster.confirm') }}</el-button>
      </span>
    </el-dialog>

    <!-- 创建云环境 授权协议-->
    <el-dialog
      :title="$t('multiCloudCluster.authorizationAgreement')"
      :visible.sync="agreeDialogVisible"
      center
      width="997px"
    >
      <div class="agree_div">
        <p>
          {{ $t('multiCloudCluster.authorizationContent1', { service: isEda ? 'EDA' : 'CAE' }) }}
        </p>
        <p>{{ $t('multiCloudCluster.authorizationContent2') }}</p>
        <p>{{ $t('multiCloudCluster.authorizationContent3') }}</p>
        <p>{{ $t('multiCloudCluster.authorizationContent4') }}</p>
        <p class="base-margin__top-10">
          {{ $t('multiCloudCluster.authorizationContent5', { service: isEda ? 'EDA' : 'CAE' }) }}
        </p>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="agreeDialogVisible = false">{{ $t('multiCloudCluster.cancel') }}</el-button>
        <el-button type="primary" @click="openCreateCloudEnvironmentDialog()">{{
          $t('multiCloudCluster.confirm')
        }}</el-button>
      </span>
    </el-dialog>

    <!--      预览ip-->
    <el-dialog
      :close-on-click-modal="false"
      :title="$t('customCluster.previewIp.previewIp')"
      :visible.sync="previewTemporaryVisible"
      append-to-body
      width="600px"
    >
      <div class="previewDialog_main--div">
        <el-table :data="previewList" :row-class-name="tableRowClassName" class="base-width_fullscreen" height="500">
          <el-table-column :label="$t('customCluster.previewIp.hostname')" prop="hostname"></el-table-column>
          <el-table-column :label="$t('customCluster.previewIp.ip')" prop="ip"></el-table-column>
        </el-table>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="exportPreviewIp(previewList)">{{
          $t('customCluster.previewIp.export')
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { postRequest } from '@/common/libs/request';
import { UTIL } from '@/common/utils';
import { mapGetters, mapState } from 'vuex';
import instanceTemplate from './components/instanceTemplate/index.vue';
import activity from './components/activity/index.vue';
import costAnalysis from './components/costAnalysis/IndexView.vue';
import { exportData, extractRegionName } from '@/common/utils/utils';

export default {
  name: 'multiCloudCluster',
  components: {
    InstanceTemplate: instanceTemplate,
    activity,
    costAnalysis,
  },
  data() {
    return {
      isEda: window.location.host.includes('eda'),
      activeName: 'partitionList',
      multiCloudList: [],
      multiCloudListLoading: false,
      partitionTotal: 0,
      partitionLimit: 10,
      partitionCurrentPage: 1,
      createPartitionDialogVisible: false,
      isCreateMultiCloudAccount: false,
      partitionFormData: {
        name: '',
        cloudEnvironment: '',
        region: '',
        zone: '',
        vpcId: '',
        subnetId: '',
        securityGroupIds: [],
        subnetCidrBlock: [],
        hostRangeList: [],
        desc: '',
      },
      cloudEnvironmentList: [],
      regionOptions: [],
      createCloudEnvironmentDialogVisible: false,
      cloudEnvironmentFormData: {
        secretId: '',
        secretKey: '',
        provider: '',
      },
      providerOptions: [
        { label: this.$t('multiCloudCluster.aliyun'), value: 'aliyun' },
        { label: this.$t('multiCloudCluster.huaweicloud'), value: 'huaweicloud' },
        { label: this.$t('multiCloudCluster.volcengine'), value: 'volcengine' },
      ],
      passDialog: false,
      isModify: false,
      modifyId: 0,
      isEditCloudEnv: false,
      editCloudEnvId: 0,
      editCloudEnvType: '',
      providerList: {
        aliyun: this.$t('multiCloudCluster.aliyun'),
        huaweicloud: this.$t('multiCloudCluster.huaweicloud'),
        volcengine: this.$t('multiCloudCluster.volcengine'),
      },
      partitionFormRules: {
        name: [{ required: true, message: this.$t('multiCloudCluster.pleaseEnterName'), trigger: 'blur' }],
        region: [{ required: true, message: this.$t('multiCloudCluster.pleaseSelectRegion'), trigger: 'change' }],
        cloudEnvironment: [
          {
            required: true,
            message: this.$t('multiCloudCluster.pleaseSelectCloudEnvironment'),
            trigger: 'change',
          },
        ],
        securityGroupIds: [
          {
            required: true,
            message: this.$t('customCluster.createCluster.rules.securityGroup'),
            trigger: 'change',
          },
        ],
        vpcId: [{ required: true, message: this.$t('customCluster.createCluster.rules.vpc'), trigger: 'change' }],
        subnetId: [{ required: true, message: this.$t('customCluster.createCluster.rules.subnet'), trigger: 'change' }],
      },
      CloudEnvFormRules: {
        secretId: [{ required: true, message: this.$t('multiCloudCluster.pleaseEnterAccessKeyId'), trigger: 'blur' }],
        secretKey: [
          {
            required: true,
            message: this.$t('multiCloudCluster.pleaseEnterAccessKeySecret'),
            trigger: 'blur',
          },
        ],
        provider: [
          {
            required: true,
            message: this.$t('multiCloudCluster.pleaseSelectCloudProvider'),
            trigger: 'change',
          },
        ],
      },
      searchName: '',
      cloudType: '',
      isFilter: false,
      agreeDialogVisible: false,
      partitionFormLoading: false,
      cloudEnvLoading: false,
      cloudEnvironmentProvider: '',
      zoneList: [],
      vpcList: [],
      subnetList: [],
      securityGroupsList: [],
      createSteps: 0,
      hostRangeListVisible: false,
      showHostRangeListForm: [],
      hostRangeListForm: [],
      defaultHostRangeListForm: [],
      hostRangeList: [],
      hostRangeListIndex: 0,
      hostRangeListType: 'add',
      previewList: [],
      hostRangeListFormIndex: false,
      previewTemporaryVisible: false,
    };
  },
  computed: {
    ...mapState(['app']),
    ...mapGetters('app', ['getCurrentProject']),
  },
  watch: {
    'app.currentProject'() {
      this.searchName = '';
      this.cloudType = '';
      this.getMulticloudPartitionList();
      this.getMultiCloudAccountList();
    },
  },

  mounted() {
    this.searchName = '';
    this.cloudType = '';
    this.getMulticloudPartitionList();
  },

  methods: {
    // 设置列表颜色
    tableRowClassName({ row }) {
      return `table_color_${row.indexNumber % 20}`; // 循环使用20种颜色
    },

    // 导出预览IP
    exportPreviewIp(item) {
      const result = item.map(item => ({
        name: item.hostname,
        ip: item.ip,
      }));
      exportData(result, this.$t('customCluster.previewIp.previewIp'));
    },

    // 下一步
    nextCreateSteps() {
      let index = JSON.parse(JSON.stringify(this.createSteps));
      if (this.createSteps === 0) {
        this.$refs.partitionForm.validate((valid) => {
          if (valid) {
            index = index + 1;
          }
        });
      }
      if (this.createSteps === 1) {
        const params = {
          hostRangeList: this.hostRangeListForm.map(item => ({
            ...item,
            startIp: item.startIp.map(ipPart => ipPart.value).join('.'),
            endIp: item.endIp.map(ipPart => ipPart.value).join('.'),
            indexStart: +item.indexStart,
            indexLength: +item.indexLength,
          })),
          subnetCidr: this.partitionFormData.subnetCidrBlock,
        };

        this.getHostnamePreview(params);
        index = index + 1;
      }
      this.createSteps = index;
    },

    /**
     * 改变子网时更新子网CIDR块和默认主机范围
     */
    changeSubnet(subnet, type) {
      if (type !== 'edit') {
        this.partitionFormData.subnetCidrBlock = '';
        this.hostRangeListForm = [];
      }
      this.subnetList.forEach((item) => {
        if (item.id === subnet) {
          this.defaultHostRangeListForm = {
            startIp: [
              { value: '', disabled: true },
              { value: '', disabled: false },
              { value: '', disabled: false },
              { value: '' },
            ],
            endIp: [
              { value: '', disabled: true },
              { value: '', disabled: false },
              { value: '', disabled: false },
              { value: '' },
            ],
            hostnamePattern: '',
            indexStart: '',
            indexLength: '',
          };
          this.partitionFormData.subnetCidrBlock = item.cidrBlock;
          const list = this.partitionFormData.subnetCidrBlock.split('.');
          const section1 = list[0];
          const section2 = list[1];
          const section3 = list[2];
          const section4 = list[3].substring(list[3].indexOf('/') + 1) / 1;
          // 根据子网掩码长度设置IP地址段
          this.defaultHostRangeListForm.startIp[0].value = section1;
          this.defaultHostRangeListForm.endIp[0].value = section1;
          if (16 <= section4 < 24) {
            // 掩码长度大于16位，固定前两段IP
            this.defaultHostRangeListForm.startIp[1].disabled = true;
            this.defaultHostRangeListForm.endIp[1].disabled = true;
            this.defaultHostRangeListForm.startIp[1].value = section2;
            this.defaultHostRangeListForm.endIp[1].value = section2;
          }
          if (section4 >= 24) {
            // 掩码长度大于等于24位，固定前三段IP
            this.defaultHostRangeListForm.startIp[1].disabled = true;
            this.defaultHostRangeListForm.startIp[2].disabled = true;
            this.defaultHostRangeListForm.endIp[1].disabled = true;
            this.defaultHostRangeListForm.endIp[2].disabled = true;
            this.defaultHostRangeListForm.startIp[1].value = section2;
            this.defaultHostRangeListForm.startIp[2].value = section3;
            this.defaultHostRangeListForm.endIp[1].value = section2;
            this.defaultHostRangeListForm.endIp[2].value = section3;
          }
        }
      });
    },

    // 完成编辑IP段
    doneEditHostRangeList() {
      if (this.hostRangeListType === 'edit') {
        this.hostRangeListForm[this.hostRangeListIndex] = this.showHostRangeListForm;
      } else {
        if (this.clusterType === 'create' && !this.hostRangeListFormIndex) {
          this.hostRangeListFormIndex = true;
          this.hostRangeListForm[0] = this.showHostRangeListForm;
        } else {
          this.hostRangeListForm.push(this.showHostRangeListForm);
        }
      }
      this.$emit('hostRangeListFormEmit', this.hostRangeListForm);
      this.hostRangeListVisible = false;
    },

    /**
     * 预览IP*/
    preview() {
      // 将startIp中的4段value合并成IP字符串
      const startIp = this.showHostRangeListForm.startIp.map(ipPart => ipPart.value).join('.');
      const endIp = this.showHostRangeListForm.endIp.map(ipPart => ipPart.value).join('.');
      const ipList = {
        ...this.showHostRangeListForm,
        indexStart: +this.showHostRangeListForm.indexStart,
        indexLength: +this.showHostRangeListForm.indexLength,
        endIp,
        startIp, // 添加合并后的IP字段
      };

      const params = {
        subnetCidr: this.partitionFormData.subnetCidrBlock,
        hostRangeList: [ipList],
      };

      this.getHostnamePreview(params);
    },

    /**
     * 获取IP预览信息
     */
    getHostnamePreview(params) {
      postRequest('/api/eda/common/multicloud/getHostnamePreview', params).then((res) => {
        this.previewList = res.relationList || [];
        if (this.createSteps === 1) {
          this.previewTemporaryVisible = true;
        }
      });
    },

    /**
     * 添加IP段
     */
    addIpRange() {
      this.hostRangeListType = 'add';
      this.hostRangeListVisible = true;
      console.log(this.defaultHostRangeListForm, 'this.defaultHostRangeListForm');
      this.showHostRangeListForm = JSON.parse(JSON.stringify(this.defaultHostRangeListForm));
    },

    // 取消添加IP
    closeHostList() {
      this.hostRangeListVisible = false;
    },

    // 删除IP段
    deleteHostRangeList(index) {
      this.hostRangeListForm.splice(index, 1);
      this.$emit('hostRangeListFormEmit', this.hostRangeListForm);
    },

    // 编辑IP段
    editHostRangeList(index, item) {
      this.hostRangeListType = 'edit';
      this.showHostRangeListForm = JSON.parse(JSON.stringify(item));
      this.hostRangeListVisible = true;
      this.hostRangeListIndex = index;
    },

    // 格式化IP
    formatIp(item) {
      return item.map(ipPart => ipPart.value).join('.');
    },

    /**
     * 获取云环境列表
     */
    getMultiCloudAccountList() {
      const data = {
        offset: 0,
        limit: 999,
      };
      postRequest('/api/eda/common/multicloud/describeMultiCloudAccountList', data).then((res) => {
        this.cloudEnvironmentList = res?.list;
      });
    },

    /**
     * 获取地区列表
     */
    getRegionsList() {
      if (!this.isModify) {
        this.partitionFormData.region = '';
        this.partitionFormData.zone = '';
        this.partitionFormData.vpcId = '';
        this.partitionFormData.subnetId = '';
        this.partitionFormData.securityGroupIds = [];
        this.partitionFormData.subnetCidrBlock = [];
        this.partitionFormData.hostRangeList = [];
        this.regionOptions = [];
        this.zoneList = [];
        this.vpcList = [];
        this.subnetList = [];
        this.securityGroupsList = [];
      }

      this.partitionFormLoading = true;
      this.cloudEnvironmentProvider = this.cloudEnvironmentList.find(item => item.Id === this.partitionFormData.cloudEnvironment).Provider;
      postRequest('/api/eda/common/multicloud/describeRegions', {
        multiCloudAccountId: this.partitionFormData.cloudEnvironment,
      })
        .then((res) => {
          if (res.regions) {
            const regionList = [];
            res.regions.forEach((item) => {
              if (item.enable) {
                regionList.push(item);
              }
            });
            this.regionOptions = regionList;
            this.partitionFormLoading = false;
          }
        })
        .catch(() => {
          this.partitionFormLoading = false;
        });
    },

    /**
     * 选择区域
     */
    changeRegion() {
      this.partitionFormData.zone = '';
      this.partitionFormData.vpcId = '';
      this.partitionFormData.subnetId = '';
      this.partitionFormData.securityGroupIds = [];
      this.partitionFormData.subnetCidrBlock = [];
      this.partitionFormData.hostRangeList = [];

      this.zoneList = [];
      this.vpcList = [];
      this.subnetList = [];
      this.securityGroupsList = [];

      this.getZonesList();
      this.getVpcList();
    },

    /**
     * 选择VPC
     */
    changeVpc() {
      this.partitionFormData.subnetId = '';
      this.partitionFormData.securityGroupIds = [];
      this.partitionFormData.subnetCidrBlock = [];
      this.partitionFormData.hostRangeList = [];
      this.subnetList = [];
      this.securityGroupsList = [];
      this.getSubnetList();
      this.getSecurityList();
    },

    /**
     * 选择地域
     */
    changeZone() {
      this.partitionFormData.subnetId = '';
      this.partitionFormData.securityGroupIds = [];
      this.partitionFormData.subnetCidrBlock = [];
      this.partitionFormData.hostRangeList = [];
      this.subnetList = [];
      this.securityGroupsList = [];
      this.getSubnetList();
      this.getSecurityList();
    },

    /**
     * 获取地域
     */
    getZonesList() {
      const regionName = extractRegionName(this.regionOptions.find(item => item.regionId === this.partitionFormData.region).regionName);

      this.partitionFormLoading = true;
      this.zoneList = [];
      if (this.cloudEnvironmentProvider === 'volcengine') {
        postRequest('/api/eda/common/volcengine/describeZones', {
          multiCloudAccountId: this.partitionFormData.cloudEnvironment,
          region: this.partitionFormData.region,
        })
          .then((res) => {
            const zoneList = res.zoneList || [];
            this.zoneList = zoneList.map(item => ({
              name: `${regionName}${item.slice(item.length - 1).toUpperCase()}区`,
              id: item,
            }));

            this.partitionFormLoading = false;
          })
          .catch(() => {
            this.partitionFormLoading = false;
          });
      }

      if (this.cloudEnvironmentProvider === 'aliyun') {
        postRequest('/api/eda/common/aliyun/describeZones', {
          multiCloudAccountId: this.partitionFormData.cloudEnvironment,
          region: this.partitionFormData.region,
        })
          .then((res) => {
            const zoneList = res.zoneList || [];
            this.zoneList = zoneList.map(item => ({
              name: `${regionName}${item.slice(item.length - 1).toUpperCase()}区`,
              id: item,
            }));

            this.partitionFormLoading = false;
          })
          .catch(() => {
            this.partitionFormLoading = false;
          });
      }

      if (this.cloudEnvironmentProvider === 'huaweicloud') {
        postRequest('/api/eda/common/huaweicloud/describeZones', {
          multiCloudAccountId: this.partitionFormData.cloudEnvironment,
          region: this.partitionFormData.region,
        })
          .then((res) => {
            const zoneList = res.zoneList || [];
            this.zoneList = zoneList.map(item => ({
              name: `${regionName}${item.slice(item.length - 1).toUpperCase()}区`,
              id: item,
            }));

            this.partitionFormLoading = false;
          })
          .catch(() => {
            this.partitionFormLoading = false;
          });
      }
    },

    /**
     * 获取VPC列表
     */
    getVpcList() {
      this.vpcList = [];
      if (this.cloudEnvironmentProvider === 'volcengine') {
        postRequest('/api/eda/common/volcengine/describeVpcs', {
          multiCloudAccountId: this.partitionFormData.cloudEnvironment,
          region: this.partitionFormData.region,
        })
          .then((res) => {
            this.vpcList = res.vpcInfoList || [];
            this.partitionFormLoading = false;
          })
          .catch(() => {
            this.partitionFormLoading = false;
          });
      }

      if (this.cloudEnvironmentProvider === 'aliyun') {
        postRequest('/api/eda/common/aliyun/describeVpcs', {
          multiCloudAccountId: this.partitionFormData.cloudEnvironment,
          region: this.partitionFormData.region,
        })
          .then((res) => {
            this.vpcList = res.vpcInfoList.Vpcs.Vpc || [];
            this.partitionFormLoading = false;
          })
          .catch(() => {
            this.partitionFormLoading = false;
          });
      }

      if (this.cloudEnvironmentProvider === 'huaweicloud') {
        postRequest('/api/eda/common/huaweicloud/describeVpcs', {
          multiCloudAccountId: this.partitionFormData.cloudEnvironment,
          region: this.partitionFormData.region,
        })
          .then((res) => {
            const list = res.vpcInfoList.map(item => ({
              VpcName: item.name,
              VpcId: item.id,
              CidrBlock: item.cidr,
            }));
            this.vpcList = list;
            this.partitionFormLoading = false;
          })
          .catch(() => {
            this.partitionFormLoading = false;
          });
      }
    },

    /**
     * 获取子网列表
     */
    getSubnetList(type) {
      this.subnetList = [];
      const params = {
        multiCloudAccountId: this.partitionFormData.cloudEnvironment,
        region: this.partitionFormData.region,
        vpcId: this.partitionFormData.vpcId,
        zone: this.partitionFormData.zone,
      };
      this.partitionFormLoading = true;
      if (this.cloudEnvironmentProvider === 'volcengine') {
        postRequest('/api/eda/common/volcengine/describeSubnets', params)
          .then((res) => {
            const subnetList
              = res.subnetInfoList.map(item => ({
                id: item.SubnetId,
                name: item.SubnetName,
                cidrBlock: item.CidrBlock,
              })) || [];
            this.subnetList = subnetList;
            if (type === 'edit') {
              this.changeSubnet(this.partitionFormData.subnetId, 'edit');
            }
            this.partitionFormLoading = false;
          })
          .catch(() => {
            this.partitionFormLoading = false;
          });
      }

      if (this.cloudEnvironmentProvider === 'aliyun') {
        postRequest('/api/eda/common/aliyun/describeVSwitches', params)
          .then((res) => {
            const subnetList
              = res.vSwitchList.map(item => ({
                id: item.VSwitchId,
                name: item.VSwitchName,
                cidrBlock: item.CidrBlock,
              })) || [];
            this.subnetList = subnetList || [];
            this.partitionFormLoading = false;
            if (type === 'edit') {
              this.changeSubnet(this.partitionFormData.subnetId, 'edit');
            }
          })
          .catch(() => {
            this.partitionFormLoading = false;
          });
      }

      if (this.cloudEnvironmentProvider === 'huaweicloud') {
        postRequest('/api/eda/common/huaweicloud/describeSubnets', params)
          .then((res) => {
            const subnetList = res.subnetInfoList.map(item => ({
              id: item.id,
              name: item.name,
              cidrBlock: item.cidr,
            })) || [];
            this.subnetList = subnetList || [];
            if (type === 'edit') {
              this.changeSubnet(this.partitionFormData.subnetId, 'edit');
            }
            this.partitionFormLoading = false;
          })
          .catch(() => {
            this.partitionFormLoading = false;
          });
      }
    },

    /**
     * 获取安全组列表
     */
    getSecurityList() {
      this.securityGroupsList = [];
      if (this.cloudEnvironmentProvider === 'volcengine') {
        postRequest('/api/eda/common/volcengine/describeSecurityGroups', {
          multiCloudAccountId: this.partitionFormData.cloudEnvironment,
          region: this.partitionFormData.region,
          vpcId: this.partitionFormData.vpcId,
        })
          .then((res) => {
            this.securityGroupsList = res.securityGroupInfoList || [];
            this.partitionFormLoading = false;
          })
          .catch(() => {
            this.partitionFormLoading = false;
          });
      }

      if (this.cloudEnvironmentProvider === 'aliyun') {
        postRequest('/api/eda/common/aliyun/describeSecurityGroups', {
          multiCloudAccountId: this.partitionFormData.cloudEnvironment,
          region: this.partitionFormData.region,
          vpcId: this.partitionFormData.vpcId,
        })
          .then((res) => {
            this.securityGroupsList = res.securityGroupList || [];
            this.partitionFormLoading = false;
          })
          .catch(() => {
            this.partitionFormLoading = false;
          });
      }

      if (this.cloudEnvironmentProvider === 'huaweicloud') {
        postRequest('/api/eda/common/huaweicloud/describeSecurityGroups', {
          multiCloudAccountId: this.partitionFormData.cloudEnvironment,
          region: this.partitionFormData.region,
          vpcId: this.partitionFormData.vpcId,
        })
          .then((res) => {
            const list = res.securityGroupInfoList.map(item => ({
              SecurityGroupId: item.id,
              SecurityGroupName: item.name,
            }));

            this.securityGroupsList = list || [];
            this.partitionFormLoading = false;
          })
          .catch(() => {
            this.partitionFormLoading = false;
          });
      }
    },

    /**
     * 创建云环境
     */
    createMultiCloudAccount() {
      this.$refs.CloudEnv.validate((valid) => {
        if (valid) {
          this.cloudEnvLoading = true;
          this.isCreateMultiCloudAccount = true;
          const data = {
            secretId: UTIL.rsaEncryption(this.cloudEnvironmentFormData.secretId),
            secretKey: UTIL.rsaEncryption(this.cloudEnvironmentFormData.secretKey),
            provider: this.cloudEnvironmentFormData.provider,
          };
          postRequest('/api/eda/common/multicloud/VerifyCloudSecret', data)
            .then(() => {
              postRequest('/api/eda/common/multicloud/createMultiCloudAccount', data)
                .then(() => {
                  this.$message.success(this.$t('multiCloudCluster.createCloudEnvironmentSuccess'));
                  this.createCloudEnvironmentDialogVisible = false;
                  this.isCreateMultiCloudAccount = false;
                  this.cloudEnvLoading = false;
                  this.getMultiCloudAccountList();
                })
                .catch(() => {
                  this.isCreateMultiCloudAccount = false;
                  this.cloudEnvLoading = false;
                });
            })
            .catch(() => {
              this.cloudEnvLoading = false;
              this.isCreateMultiCloudAccount = false;
            });
        }
      });
    },

    /**
     * 创建分区
     */
    createMulticloudPartition() {
      this.partitionFormLoading = true;
      const data = {
        name: this.partitionFormData.name,
        description: this.partitionFormData.desc,
        region: this.partitionFormData.region,
        multiCloudAccountId: this.partitionFormData.cloudEnvironment,
        zone: this.partitionFormData.zone,
        vpcId: this.partitionFormData.vpcId,
        subnetId: this.partitionFormData.subnetId,
        subnetCidrBlock: this.partitionFormData.subnetCidrBlock,
        securityGroupIds: this.partitionFormData.securityGroupIds,
        hostRangeList: this.hostRangeListForm.map(item => ({
          ...item,
          startIp: item.startIp.map(ipPart => ipPart.value).join('.'),
          endIp: item.endIp.map(ipPart => ipPart.value).join('.'),
          indexStart: +item.indexStart,
          indexLength: +item.indexLength,
        })),
      };
      postRequest('/api/eda/common/multicloud/createMultiCloudPartition', data)
        .then(() => {
          this.$message.success(this.$t('multiCloudCluster.createPartitionSuccess'));
          this.partitionFormLoading = false;
          this.createPartitionDialogVisible = false;
          this.getMulticloudPartitionList();
        })
        .catch(() => {
          this.partitionFormLoading = false;
        });
    },

    /**
     * 获取分区列表
     */
    getMulticloudPartitionList() {
      const offset = this.partitionLimit * (this.partitionCurrentPage - 1);
      const data = {
        offset,
        limit: this.partitionLimit,
        filters: [],
      };
      if (this.cloudType || this.searchName) {
        this.isFilter = true;
        if (this.cloudType) {
          const obj = {};
          obj.name = 'provider';
          obj.values = [this.cloudType];
          data.filters.push(obj);
        }
        if (this.searchName) {
          const obj = {};
          obj.name = 'name';
          obj.values = [this.searchName];
          data.filters.push(obj);
        }
      } else {
        this.isFilter = false;
      }
      this.multiCloudListLoading = true;
      postRequest('/api/eda/common/multicloud/describeMultiCloudPartitionList', data).then((res) => {
        this.multiCloudList = res?.partitionList;
        this.partitionTotal = res?.totoalCount;
        this.multiCloudListLoading = false;
      }).catch(() => {
        this.multiCloudListLoading = false;
      });
    },

    /**
     * 打开修改分区弹窗
     * @param val 分区信息
     */
    modify(val) {
      this.isModify = true;
      this.modifyId = val.Id;

      this.partitionFormData = {
        name: val.Name,
        cloudEnvironment: val.MultiCloudAccountId,
        region: val.Region,
        zone: val.Zone,
        vpcId: val.VpcId,
        subnetId: val.SubnetId,
        securityGroupIds: val.SecurityGroupIds,
        desc: val.Description,
      };

      this.hostRangeListForm = val.HostRangeList;
      this.openCreatePartitionDialog();
      setTimeout(() => {
        this.getRegionsList();
      }, 500);

      setTimeout(() => {
        this.getVpcList();
        this.getSubnetList('edit');
        this.getZonesList();
        this.getSecurityList();
        this.analysisIpRange(val.HostRangeList, val.SubnetCidrBlock);
      }, 2000);

      this.partitionFormData.subnetCidrBlock = val.SubnetCidrBlock;
    },

    /**
     * 复制集群时
     * 分析ip范围
     * 重新解析ip范围，并更新表单数据
     * */
    analysisIpRange(list, cidr) {
      const cidrList = cidr.split('.');
      const maskLength = Number(cidrList[3].substring(cidrList[3].indexOf('/') + 1));

      // 根据掩码长度计算需要禁用的IP段数量
      const getDisabledCount = (mask) => {
        if (mask < 16) return 1;
        if (mask < 24) return 2;
        return 3;
      };
      const disabledCount = getDisabledCount(maskLength);

      const ipList = list.map((item) => {
        // 处理IP段的通用函数
        const processIp = ip => ip.split('.').map((part, index) => ({
          value: part,
          disabled: index < disabledCount, // 根据需要禁用的数量设置状态
        }));

        item.startIp = processIp(item.startIp);
        item.endIp = processIp(item.endIp);
        return item;
      });

      this.hostRangeListForm = ipList;
    },

    /**
     * 删除分区
     * @param val 分区信息
     */
    deleteMultiCloudPartition(val) {
      this.$confirm(this.$t('multiCloudCluster.confirmDeletePartition'), this.$t('multiCloudCluster.deletePartition'), {
        confirmButtonText: this.$t('multiCloudCluster.confirm'),
      })
        .then(() => {
          postRequest('/api/eda/common/multicloud/deleteMultiCloudPartition', { multiCloudPartitionId: val.Id }).then(() => {
            this.$message.success(this.$t('multiCloudCluster.deleteSuccess'));
            this.getMulticloudPartitionList();
          });
        })
        .catch(() => {});
    },

    /**
     * 修改分区
     */
    modifyPartition() {
      if (this.partitionFormData.name === '') return this.$message.warning('请输入分区名称');
      if (this.partitionFormData.securityGroupIds.length === 0) return this.$message.warning('请选择安全组');
      this.partitionFormLoading = true;
      const data = {
        multiCloudPartitionId: this.modifyId,
        name: this.partitionFormData.name,
        // description: this.partitionFormData.desc,
        // region: this.partitionFormData.region,
        // multiCloudAccountId: this.partitionFormData.cloudEnvironment,
        securityGroupIds: this.partitionFormData.securityGroupIds,
      };
      postRequest('/api/eda/common/multicloud/modifyMultiCloudPartition', data)
        .then(() => {
          this.$message.success(this.$t('multiCloudCluster.modifySuccess'));
          this.partitionFormLoading = false;
          this.createPartitionDialogVisible = false;
          this.getMulticloudPartitionList();
        })
        .catch(() => {
          this.partitionFormLoading = false;
        });
    },

    /**
     * 分页器每页条数改变
     */
    partitionSizeChange(limit) {
      this.partitionCurrentPage = 1;
      this.partitionLimit = limit;
      this.getMulticloudPartitionList();
    },

    /**
     * 分页器当前页改变
     */
    partitionCurrentChange(currentPage) {
      this.partitionCurrentPage = currentPage;
      this.getMulticloudPartitionList();
    },

    /**
     * 打开修改云环境弹窗
     */
    edit(val) {
      this.isEditCloudEnv = true;
      this.editCloudEnvId = val.Id;
      this.editCloudEnvType = val.Provider;
      this.openCreateCloudEnvironmentDialog('');
    },

    /**
     * 切换tab 获取云环境列表
     */
    tabClick(val) {
      if (val.name === 'partitionList') {
        this.searchName = '';
        this.cloudType = '';
        this.getMulticloudPartitionList();
      }
      if (val.name === 'cloudEnvironment') {
        this.getMultiCloudAccountList();
      }
    },

    /**
     * 打开创建分区弹窗
     */
    openCreatePartitionDialog() {
      this.createPartitionDialogVisible = true;
      this.getMultiCloudAccountList();
    },

    /**
     * 创建云环境 授权协议
     */
    openAgreeDialog(val) {
      this.passDialog = val;
      this.agreeDialogVisible = true;
    },

    /**
     * 打开创建云环境弹窗
     */
    openCreateCloudEnvironmentDialog() {
      this.agreeDialogVisible = false;
      this.createCloudEnvironmentDialogVisible = true;
    },

    /**
     * 修改云环境
     */
    editCloudEnv() {
      if (this.cloudEnvironmentFormData.secretId === '' || this.cloudEnvironmentFormData.secretKey === '') {
        return this.$message.warning(this.$t('multiCloudCluster.pleaseEnterCompleteParams'));
      }
      this.cloudEnvLoading = true;
      const varifyData = {
        secretId: UTIL.rsaEncryption(this.cloudEnvironmentFormData.secretId),
        secretKey: UTIL.rsaEncryption(this.cloudEnvironmentFormData.secretKey),
        provider: this.editCloudEnvType,
      };
      const data = {
        secretId: UTIL.rsaEncryption(this.cloudEnvironmentFormData.secretId),
        secretKey: UTIL.rsaEncryption(this.cloudEnvironmentFormData.secretKey),
        id: this.editCloudEnvId,
      };
      // 验证密钥
      postRequest('/api/eda/common/multicloud/VerifyCloudSecret', varifyData)
        .then(() => {
          // 创建云环境
          postRequest('/api/eda/common/multicloud/modifyMultiCloudAccount', data)
            .then(() => {
              this.$message.success(this.$t('multiCloudCluster.modifySuccess'));
              this.createCloudEnvironmentDialogVisible = false;
              this.getMultiCloudAccountList();
            })
            .catch(() => {
              this.cloudEnvLoading = false;
            });
        })
        .catch(() => {
          this.cloudEnvLoading = false;
        });
    },

    /**
     * 删除云环境
     */
    deleteCloudEnv(id) {
      this.$confirm(
        this.$t('multiCloudCluster.confirmDeleteCloudEnvironment'),
        this.$t('multiCloudCluster.deleteCloudEnvironment'),
        {
          confirmButtonText: this.$t('multiCloudCluster.confirm'),
        },
      )
        .then(() => {
          postRequest('/api/eda/common/multicloud/deleteMultiCloudAccount', { id }).then(() => {
            this.$message.success(this.$t('multiCloudCluster.deleteSuccess'));
            this.getMultiCloudAccountList();
          });
        })
        .catch(() => {});
    },

    /**
     * 跳转到云环境详情页
     */
    toDetail(val) {
      this.$router.push({
        path: 'multiCloudClusterDetail',
        query: { id: val.Id, name: val.Name, type: String(val.Provider) },
      });
    },

    /**
     * 关闭分区弹窗清空数据
     */
    closePartitionDialog() {
      this.isModify = false;
      if (this.createSteps === 0) {
        this.$refs.partitionForm.clearValidate();
      }
      this.createSteps = 0;
      this.partitionFormData = {
        name: '',
        cloudEnvironment: '',
        region: '',
        zone: '',
        vpcId: '',
        subnetId: '',
        securityGroupIds: [],
        subnetCidrBlock: [],
        hostRangeList: [],
        desc: '',
      };
      this.hostRangeListForm = [];
    },

    /**
     * 关闭云环境弹窗清空数据
     */
    clearCloudEnvironmentFormData() {
      this.isEditCloudEnv = false;
      this.$refs.CloudEnv.clearValidate();
      this.cloudEnvironmentFormData = {
        secretId: '',
        secretKey: '',
        provider: '',
      };
    },

    /**
     * 加密
     */
    processSecretID(id) {
      if (!id) {
        return '-';
      }
      if (id.length > 16) {
        const first = id.slice(0, 8);
        const end = id.slice(id.length - 8);
        return `${first}***${end}`;
      }
      return id;
    },
  },
};
</script>

<style lang="scss" scoped>
.multiCloudCluster-container {
  height: 100%;

  .multiCloudCluster-head {
    height: 30px;
  }

  .multiCloudCluster-tab {
    height: calc(100% - 30px);

    ::v-deep .el-tabs__header {
      padding: 0 20px;
      background: #fff;
    }

    ::v-deep .el-tabs__content {
      height: calc(100% - 55px);
      margin: 0 20px;
    }

    .el-tab-pane {
      height: 100%;
    }

    .multiCloudCluster-tab__container {
      height: 100%;
      width: 100%;

      ::v-deep .el-table {
        .el-table__body-wrapper {
          overflow-y: auto !important;
        }
      }
    }
  }

  .empty {
    height: 100%;
  }
}

// table 背景颜色+padding10px
.table_box {
  background: #fff;
  padding: 10px;
  height: calc(100% - 42px);

  .table {
    height: calc(100% - 42px);

    ::v-deep .el-table__body-wrapper {
      height: calc(100% - 42px);
      overflow-y: auto;
    }
  }

  // table内容部分下边距和最小高度
  .el-table {
    margin-bottom: 10px;
    min-height: 264px;
  }
}

.textarea-style {
  ::v-deep .el-textarea__inner {
    resize: none;
  }
}

.cloudEnvironment-container {
  padding: 20px;
  display: flex;
  flex-wrap: wrap;
  height: 100%;

  .cloudEnvironment-container__card {
    width: 300px;
    height: 200px;
    box-shadow: 0 0 12px 0 rgba(54, 58, 80, 0.32);
    padding: 10px;
    font-size: 12px;
    margin: 0 20px 20px 0;

    .card_left {
      width: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;

      img {
        width: 52px;
        height: 32px;
        margin: 20px 0;
      }
    }

    .card_head-icon {
      height: 14px;
      text-align: right;
      font-size: 14px;

      i {
        cursor: pointer;
        margin-left: 10px;
      }
    }

    .card_right {
      width: 40%;
      display: none;

      .card_right-info {
        margin-top: 10px;
      }

      .card_right-info > div {
        display: flex;
        margin-bottom: 10px;

        div {
          width: 60px;
          display: flex;
          justify-content: space-between;
        }
      }

      .card_right-info > div > span {
        margin-left: 5px;
      }
    }
  }

  .cloudEnvironment-container__card > div:last-child {
    word-break: break-word;
    text-align: center;
  }
}

.agree_div {
  line-height: 1.5;
  font-family: 'PingFang SC';
}

.provider_div {
  img {
    width: 14px;
    height: 14px;
  }
}

.ipBox {
  height: 126px;
  padding: 8px;
  margin-bottom: 10px;

  span {
    line-height: 36px;
    margin-right: 8px;
  }
}

.box_clas {
  ::v-deep .el-step__title {
    font-size: 12px !important;
  }
}

.startIp_input {
  .el-input {
    margin-right: 10px;
    width: 54px;
  }

  ::v-deep .el-input__inner {
    text-align: center;
    -moz-appearance: textfield;
  }

  ::v-deep .el-input__inner::-webkit-inner-spin-button,
  ::v-deep .el-input__inner::-webkit-outer-spin-button {
    -webkit-appearance: none !important;
    margin: 0;
  }
}

.preview_div--button {
  position: absolute;
  top: 12px;
  left: 630px;
}

.tips_cls {
  color: #999;
  font-size: 10px;
  margin-bottom: 14px;
  margin-left: 60px;
}

.div-width__180 {
  width: 180px !important;
}
</style>
<style>
/* 淡雅绿色系 */
.table_color_0 {
  background-color: rgba(232, 245, 233, 0.3) !important;
}

/* 极浅绿 */
.table_color_1 {
  background-color: rgba(220, 237, 200, 0.3) !important;
}

/* 薄荷绿 */
.table_color_2 {
  background-color: rgba(200, 230, 201, 0.3) !important;
}

/* 嫩芽绿 */

/* 柔和蓝色系 */
.table_color_3 {
  background-color: rgba(227, 242, 253, 0.3) !important;
}

/* 淡天蓝 */
.table_color_4 {
  background-color: rgba(187, 222, 251, 0.3) !important;
}

/* 浅湖蓝 */
.table_color_5 {
  background-color: rgba(144, 202, 249, 0.3) !important;
}

/* 婴儿蓝 */

/* 浅灰紫色系 */
.table_color_6 {
  background-color: rgba(243, 229, 245, 0.3) !important;
}

/* 薰衣草 */
.table_color_7 {
  background-color: rgba(225, 190, 231, 0.3) !important;
}

/* 浅紫灰 */
.table_color_8 {
  background-color: rgba(209, 196, 233, 0.3) !important;
}

/* 淡丁香 */

/* 暖米色系 */
.table_color_9 {
  background-color: rgba(255, 248, 225, 0.3) !important;
}

/* 米白 */
.table_color_10 {
  background-color: rgba(255, 236, 179, 0.3) !important;
}

/* 浅香槟 */
.table_color_11 {
  background-color: rgba(255, 224, 178, 0.3) !important;
}

/* 杏黄 */

/* 冷灰色系 */
.table_color_12 {
  background-color: rgba(245, 245, 245, 0.3) !important;
}

/* 白灰 */
.table_color_13 {
  background-color: rgba(238, 238, 238, 0.3) !important;
}

/* 浅灰 */
.table_color_14 {
  background-color: rgba(224, 224, 224, 0.3) !important;
}

/* 中灰 */

/* 特殊混合色 */
.table_color_15 {
  background-color: rgba(224, 247, 250, 0.3) !important;
}

/* 冰蓝 */
.table_color_16 {
  background-color: rgba(232, 245, 233, 0.3) !important;
}

/* 水绿 */
.table_color_17 {
  background-color: rgba(241, 248, 233, 0.3) !important;
}

/* 玉绿 */
.table_color_18 {
  background-color: rgba(249, 251, 231, 0.3) !important;
}

/* 珍珠白 */
.table_color_19 {
  background-color: rgba(255, 253, 231, 0.3) !important;
}

/* 象牙白 */
</style>
